import React from 'react'
import styled  from 'styled-components'

import { MINTTOKEN } from '../../../constants/bakery'
// import { supportedNewPools } from '../../../sushi/lib/constants'

const TabsWrapper = styled.div`
  display: flex;
  align-items: center;
  font-family: Baloo Da;
  width: 892px;
  margin-bottom: 40px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
  `}
  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
  `}
`

const activeClassName = 'ACTIVENAV'
const TabItem = styled.div.attrs({
  activeClassName
})`
  position: relative;
  color: ${({ theme }) => theme.bsText2};
  cursor: pointer;
  font-size: 22px;
  font-weight: bold;
  text-decoration: none;
  white-space:nowrap;
  margin-right: 60px;

  &.${activeClassName} {
    color: ${({ theme }) => theme.text1};
    font-size: 22px;
    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      background: ${({ theme }) => theme.text1};
      border-radius: 2px;
      width: 100%;
      height: 4px;
    }
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-right: 16px;
  `};
`
const IconFlag =  styled.img`
  position: absolute;
  top: -10px;
  left: calc(100% - 15px);
  width: auto;
`
export default function Tabs({tokenName, toggleTab}: {tokenName: string, toggleTab: (tab: string) => void}) {
  return (
    <TabsWrapper>
      {/* {supportedNewPools.length > 0 && <TabItem className={tokenName === MINTTOKEN.ALLNEW ? activeClassName : ''} onClick={toggleTab.bind(null, MINTTOKEN.ALLNEW, 'hot')}>
        <img src="/images/icon_fire.svg" style={{marginRight:4}} alt="icon_fire"/>
        Hot
        <IconFlag src={'/images/icon_v2.svg'} width={24} />
      </TabItem>} */}
      <TabItem className={tokenName === MINTTOKEN.BAKEV2 ? activeClassName : ''} onClick={toggleTab.bind(null, MINTTOKEN.BAKEV2)}>
        Earn BAKE
        <IconFlag src={'/images/icon_v2.svg'} width={24} />
      </TabItem>
      <TabItem className={tokenName === MINTTOKEN.OTHERS ? activeClassName : ''} onClick={toggleTab.bind(null, MINTTOKEN.OTHERS)}>Earn Others
      <IconFlag src={'/images/icon_v2.svg'} width={24} />
      </TabItem>
      <TabItem className={tokenName === MINTTOKEN.ALLNFT ? activeClassName : ''} onClick={toggleTab.bind(null, MINTTOKEN.ALLNFT)}>NFT</TabItem>
      <TabItem className={tokenName === MINTTOKEN.BAKE ? activeClassName : ''} onClick={toggleTab.bind(null, MINTTOKEN.BAKE)}>
        V1
        <IconFlag src={'/images/ended.png'} width={24} height={20} />
      </TabItem>
      <TabItem className={tokenName === MINTTOKEN.ENDED ? activeClassName : ''} onClick={toggleTab.bind(null, MINTTOKEN.ENDED)}>Ended</TabItem>
      {/* <TabItem className={tokenName === MINTTOKEN.BAKESTAKING ? activeClassName : ''} onClick={toggleTab.bind(null, MINTTOKEN.BAKESTAKING)}>BAKE Staking</TabItem>
      <TabItem className={tokenName === MINTTOKEN.HELMETNFT ? activeClassName : ''} onClick={toggleTab.bind(null, MINTTOKEN.HELMETNFT)}>Earn NFT</TabItem>
      <TabItem className={tokenName === MINTTOKEN.NFTSTAKE ? activeClassName : ''} onClick={toggleTab.bind(null, MINTTOKEN.NFTSTAKE)}>NFT Staking</TabItem> */}
      {/* <TabItem className={tokenName === MINTTOKEN.WEAPON ? activeClassName : ''} onClick={toggleTab.bind(null, MINTTOKEN.WEAPON)}>Earn WEAPON</TabItem> */}
      {/* <TabItem className={tokenName === MINTTOKEN.PET ? activeClassName : ''} onClick={toggleTab.bind(null, MINTTOKEN.PET)}>Earn PET</TabItem> */}
      {/* <TabItem className={tokenName === MINTTOKEN.BPET ? activeClassName : ''} onClick={toggleTab.bind(null, MINTTOKEN.BPET)}>Battle Pets</TabItem> */}
    </TabsWrapper>
  )
}
